/**
 * Display formatters for the contractor workspace. Dates and money live in
 * ./dates and ./money; this module re-exports them under the names screens
 * already import, so `import { formatDate, formatMoney } from './format'`
 * keeps working.
 */
import { formatDate, formatDateTime, formatTime, todayLocalISO, toLocalISODate, parseUkDate, isPastDate } from './dates';
import { formatGBP, toPence, fromPence, sumPence, parseAmount } from './money';

export { formatDate, formatDateTime, formatTime, todayLocalISO, toLocalISODate, parseUkDate, isPastDate };
export { formatGBP, toPence, fromPence, sumPence, parseAmount };

/**
 * Number / money string → "£1,850.50" (en-GB, GBP, always 2dp; negatives "−£500.00").
 * Empty → "—". Non-numeric strings pass through.
 */
export const formatMoney = (v) => formatGBP(v);

/** A job's display reference: the formatted job_number (e.g. JOB-0001) when set, else #id. */
export const formatJobNo = (jobNumber, id) => {
  const n = jobNumber == null ? '' : String(jobNumber).trim();
  return n || `#${id}`;
};

/** "1 task" / "3 tasks" — avoids "1 tasks". Pass `plural` for irregulars. */
export const plural = (n, singular, pluralForm = `${singular}s`) => `${n} ${Number(n) === 1 ? singular : pluralForm}`;

export default formatDate;
